












import { Component, Inject, Vue } from "vue-property-decorator";
import { IOpen } from "../type";
@Component
export default class Open extends Vue {
  @Inject()
  someValue!: IOpen;

  get type() {
    return this.someValue.type === 1 ? "现金红包" : "积分红包";
  }

  close(call: boolean) {
    this.$emit("close", call);
  }
}
